import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { BoardTaskCard } from './BoardTaskCard';

interface Task {
  id: string;
  task_title: string;
  status: string;
  due_date: string | null;
  assignees: any[];
  checkpoints: any[];
  category_type: string;
  estimated_hours: number | null;
}

interface DroppableColumnProps {
  column: {
    id: string;
    label: string;
    icon: string;
    bgColor: string;
  };
  tasks: Task[];
  onViewDetails: (task: Task) => void;
}

export function DroppableColumn({ column, tasks, onViewDetails }: DroppableColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex-shrink-0 w-80 ${column.bgColor} rounded-lg p-4 border transition-all ${
        isOver ? 'ring-2 ring-primary ring-offset-2' : ''
      }`}
    >
      {/* Column Header */}
      <div className="flex items-center justify-between mb-4 pb-3 border-b">
        <div className="flex items-center gap-2">
          <span className="text-2xl">{column.icon}</span>
          <h3 className="font-semibold text-foreground">{column.label}</h3>
        </div>
        <span className="bg-background px-2 py-1 rounded-full text-sm font-medium">
          {tasks.length}
        </span>
      </div>

      {/* Sortable Items Container */}
      <SortableContext
        items={tasks.map(t => t.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="space-y-3 min-h-[200px]">
          {tasks.map((task) => (
            <BoardTaskCard 
              key={task.id} 
              task={task}
              onViewDetails={onViewDetails}
            />
          ))}
          
          {tasks.length === 0 && (
            <div className="text-center text-muted-foreground py-8 text-sm">
              No tasks
            </div>
          )}
        </div>
      </SortableContext>
    </div>
  );
}
